import { UIHeading5, Image } from '@cian/ui-kit';
import * as React from 'react';

import styles from './ChatMessageUserName.css';
import { EUserColor } from '../../types/userName';

interface IChatMessageUserNameProps {
  userName?: string;
  nameReplacementImageUrl?: string;
  userColor: EUserColor;
}

export const ChatMessageUserName: React.FC<IChatMessageUserNameProps> = ({
  userName,
  nameReplacementImageUrl,
  userColor,
}) => {
  return (
    <>
      {userName && !nameReplacementImageUrl && (
        <div className={styles[`user-name_color_${userColor}`]}>
          <UIHeading5>{userName}</UIHeading5>
        </div>
      )}

      {nameReplacementImageUrl && (
        <div className={styles['name-replacement-image']}>
          <Image height={18} src={nameReplacementImageUrl} display="inline-block" />
        </div>
      )}
    </>
  );
};
